// RFC 4122 v4 UUID. Uses crypto.getRandomValues when available, otherwise
// falls back to Math.random (NOT crypto-grade — only used as a last resort).
export function uuidv4() {
  var bytes;
  try {
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
    }
  } catch (e) {
    bytes = null;
  }
  if (!bytes) {
    bytes = new Array(16);
    for (var i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
  var hex = [];
  for (var j = 0; j < 16; j++) {
    var h = bytes[j].toString(16);
    hex.push(h.length === 1 ? '0' + h : h);
  }
  return (
    hex[0] + hex[1] + hex[2] + hex[3] + '-' +
    hex[4] + hex[5] + '-' +
    hex[6] + hex[7] + '-' +
    hex[8] + hex[9] + '-' +
    hex[10] + hex[11] + hex[12] + hex[13] + hex[14] + hex[15]
  );
}
